<div class="vp-wrapper">
  <div class="vp-card">
    <!-- Logo -->
    <div class="vp-logo">
      <img alt="Logo" src="/logo-login.svg"/>
    </div>
    <!-- Success Icon -->
    <div class="vc-icon-wrap">
      <svg fill="none" height="32" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
           stroke-width="2.5" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </div>
    <!-- Heading -->
    <h2 class="vp-title">Verification Complete</h2>
    <p class="vp-subtitle">
      Your email and mobile number have been successfully verified.
    </p>
    <!-- Close message -->
    <p *ngIf="showCloseMessage" class="vc-close-hint">
      You can now safely close this tab.
    </p>
  </div>
</div>
